var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepeat04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17393_46961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2054 17.2952C14.1174 17.2876 17.2827 14.1102 17.2751 10.1982C17.2706 7.84361 16.1177 5.75955 14.3474 4.47501M11.0418 18.8769L9.37194 17.2134L11.0354 15.5436M10.1782 3.12853C6.26616 3.13606 3.10095 6.31348 3.10848 10.2255C3.11301 12.5801 4.26592 14.6642 6.03617 15.9487M9.3482 4.88013L11.0117 3.21026L9.34179 1.54681",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17393_46961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.172852 0.231201) rotate(-0.110297)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat04);
export default __webpack_public_path__ + "static/media/repeat-04.6ad5e2f3f5f693ec6a8c1fe1e4255d19.svg";
export { ForwardRef as ReactComponent };